(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );
(() => {
  const hoverScreen = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );
  const closeTimers = new WeakMap();
  const selector = '.header__inline-menu details';

  function setMenuState(details, open) {
    const wasOpen = details.open;
    const animationElements = details.matches('.mega-menu')
      ? [
          details.querySelector('.mega-menu__content'),
          details.querySelector('.mega-menu__list')
        ].filter(Boolean)
      : [];

    // Reset bij sluiten of bij een echte nieuwe opening.
    // Bewegen tussen links in een open menu start niets opnieuw.
    if (!open || !wasOpen) {
      animationElements.forEach((element) => {
        element.style.setProperty('animation', 'none', 'important');
      });
    }

    details.open = open;

    const summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.setAttribute('aria-expanded', String(open));
    }

    if (open && !wasOpen && animationElements.length) {
      // Laat de browser de reset verwerken voordat de CSS-animatie terugkomt.
      void animationElements[0].offsetWidth;
      animationElements.forEach((element) => {
        element.style.removeProperty('animation');
      });
    }
  }

  document.addEventListener('pointerover', (event) => {
    if (!hoverScreen.matches || event.pointerType !== 'mouse') return;
    if (!(event.target instanceof Element)) return;

    let details = event.target.closest(selector);

    while (details) {
      clearTimeout(closeTimers.get(details));
      setMenuState(details, true);
      details = details.parentElement?.closest(selector);
    }
  });

  document.addEventListener('pointerout', (event) => {
    if (!hoverScreen.matches || event.pointerType !== 'mouse') return;
    if (!(event.target instanceof Element)) return;

    let details = event.target.closest(selector);

    while (details) {
      const menu = details;

      if (
        !(event.relatedTarget instanceof Node) ||
        !menu.contains(event.relatedTarget)
      ) {
        clearTimeout(closeTimers.get(menu));

        closeTimers.set(
          menu,
          setTimeout(() => {
            // Sluit niet terwijl iemand het submenu met het
            // toetsenbord gebruikt of er met de muis in staat.
            if (
              !menu.matches(':hover') &&
              !menu.contains(document.activeElement)
            ) {
              setMenuState(menu, false);
            }
          }, 200)
        );
      }

      details = details.parentElement?.closest(selector);
    }
  });
})();
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
